import React from "react";
import { FaCircleCheck } from "react-icons/fa6";

const PricingPlans = () => {
  const generateWhatsAppLink = () => {
    const phoneNumber = "+923204192824"; // Updated with Pakistan's country code
    const url = `https://wa.me/${phoneNumber}`;
    return url;
  };

  return (
    <div className="bg-white py-16 px-6 md:px-24">
      {/* Header */}
      <div className="text-center">
        <h2 className="text-4xl font-bold text-gray-800 uppercase">
          Our Specialized Services
        </h2>
        <div className="border-t-4 border-yellow-500 mt-2 w-20 mx-auto"></div>
      </div>

      {/* Plans Section */}
      <div className="mt-12 max-w-7xl mx-auto grid lg:grid-cols-3 gap-8">
        {/* Included with All Plans */}
        <div className="p-6 bg-gray-100 rounded-lg shadow-md">
          <h3 className="text-lg font-semibold mb-4">
            All Tech Solutions
          </h3>
          <ul className="space-y-4">
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Custom Software 
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Gaming App
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Business Management
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Business Development 
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Strategic Plans 
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Brand Designing
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Corporate Shoots
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Media Marketing
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Hosting Domain
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> UK USA Company
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Stripe Creation
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> META ads
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Agency Creation
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Jobs & Referrals
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /> </span> Taxation Services
            </li>
          </ul>
        </div>

        {/* Gold Plan */}
        <div className="bg-white rounded-xl shadow-md relative">
          <div className=" rounded-t-xl bg-gray-600 px-4 font-semibold text-white">
            <div className="bg-gray-600 w-[100%] h-6"></div>
            <h2 className="bg-yellow-500 w-[100%] rounded-t-xl px-3 py-1 font-semibold text-xl">Software Solutions</h2>
          </div>
          <h3 className="text-xl font-bold mt-8 mb-4 px-6">Helps to Automate Business</h3>
          <ul className="space-y-4 border-t border-b py-3 mb-3 p-6">
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> CRM, ERP, HRM 
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Finance Management
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Inventory Management
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Restaurant Management
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Pharmacy Management
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Food Order System
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Learning Management System
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> School/College Management Software
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Automatic Marketing Software
            </li>
            {/* <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Point of Sale (POS)
            </li> */}
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Mobile App
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Gaming App
            </li>
            {/* <p className="text-blue-500 mt-4 cursor-pointer">6 More Features</p> */}
          </ul>
          <a
            href={generateWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-black to-logo text-white mt-6 mx-6 px-6 py-2 rounded-lg font-semibold"
          >
            Submit Request
          </a>
        </div>

        {/* Platinum Plan */}
        <div className=" bg-white rounded-lg shadow-md relative">
          <div className=" rounded-t-xl bg-gray-600 px-4 font-semibold text-white">
            <div className="bg-gray-600 w-[100%] h-6"></div>
            <h2 className="bg-yellow-500 w-[100%] rounded-t-xl px-3 py-1 font-semibold text-xl">Web Development</h2>
          </div>
          <h3 className="text-xl font-bold mt-8 mb-4 px-6">Helps to Create Identity</h3>
          <ul className="space-y-4 border-t border-b px-6 py-3 mb-3">
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Static Website
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Dynamic Website
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> E-commerce Website
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Portal Website
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Wiki Website
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Forum Website
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Affiliate Website
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Directory Website
            </li>
            {/* <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Landing Page Website
            </li> */}
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Single-page Application (SPA)
            </li>
            {/* <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Web Application
            </li> */}
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Progressive Web App (PWA)
            </li>
            <li className="flex items-center">
              <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Multimedia Website
            </li>
            {/* <p className="text-blue-500 mt-4 cursor-pointer">8 More Features</p> */}
          </ul>
          <a
            href={generateWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-black to-logo text-white mt-6 mx-6 px-6 py-2 rounded-lg font-semibold"
          >
            Submit Request
          </a>
        </div>
      </div>

      {/* Additional Usage */}
      <div className="container mx-auto mt-12">
        <h4 className="text-lg font-bold text-center">OTHER SERVICES</h4>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
          <div className="flex items-start justify-start">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Live Course
          </div>
          <div className="flex items-start justify-start">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Training Programs
          </div>
          <div className="flex items-start justify-start">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Business Partnerships
          </div>
          <div className="flex items-start justify-start">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Investment Opportunities
          </div>
          <div className="flex items-start justify-start">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Career Advice
          </div>
          <div className="flex items-start justify-start">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Personal Coaching
          </div>
          <div className="flex items-start justify-start">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Guides & E-Books
          </div>
          <div className="flex items-start justify-start">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Job Referrals
          </div>
          {/* <div className="flex items-center justify-center">
            <span className="text-green-500 mr-2"><FaCircleCheck size={18} /></span> Local Minutes: $0.05 ea.
          </div> */}
        </div>
      </div>


    </div>
  );
};

export default PricingPlans;
